const generatedImages = new Map();
const escapeSvg = (value) => String(value).replace(/[&<>"']/g, (char) => ({
  "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;",
})[char]);

// 只使用当前条目的真实品牌、料号，不用搜索词或文章标题补造型号。
export function createSearchImageFallback(item = {}) {
  const model = String(
    item.imageModel ?? (item.goodsNum || item.goods_num || item.product_part_number ||
    item.model || item.number || item.partNumber || "")
  ).trim();
  const brand = String(item.brand || item.goodsBrand || item.goods_brand || "").trim();
  const category = String(item.imageCategory ?? item.category ?? item.goodsCategoryName ?? "").trim();
  const subtitle = category || brand;
  const placeholder = require("@/assets/default-goods.png");
  if (!model || item.fallbackTitleKey) return placeholder;
  const key = JSON.stringify([model, subtitle]);
  if (generatedImages.has(key)) return generatedImages.get(key);
  // 沿用 dev 搜索页 chip-thumb 的渐变底、上下引脚和型号／分类排版。
  const chars = Array.from(model);
  const lineCount = Math.min(3, Math.ceil(chars.length / 14));
  const lineLength = Math.ceil(chars.length / lineCount);
  const fontSize = Math.min(28, 190 / (lineLength * 0.65));
  const lines = Array.from({ length: lineCount }, (_, index) =>
    chars.slice(index * lineLength, (index + 1) * lineLength).join(""));
  const startY = (subtitle ? 88 : 104) - (lineCount - 1) * (fontSize + 4) / 2;
  const subtitleSize = Math.min(22, 190 / (Array.from(subtitle).length || 1));
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="200" viewBox="0 0 240 200">
    <defs>
      <linearGradient id="chip" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#1f2937"/><stop offset="1" stop-color="#40506a"/></linearGradient>
      <pattern id="pins" width="18" height="4" patternUnits="userSpaceOnUse"><rect width="9" height="4" fill="#fff" fill-opacity=".55"/></pattern>
    </defs>
    <rect x="1" y="1" width="238" height="198" rx="16" fill="url(#chip)" stroke="#dce2ea" stroke-width="2"/>
    <rect x="24" y="20" width="192" height="4" fill="url(#pins)"/><rect x="24" y="176" width="192" height="4" fill="url(#pins)"/>
    <g font-family="Arial, 'Microsoft YaHei', sans-serif" text-anchor="middle">
      ${lines.map((line, index) => `<text x="120" y="${startY + index * (fontSize + 4)}" fill="#fff" font-size="${fontSize}" font-weight="700">${escapeSvg(line)}</text>`).join("")}
      ${subtitle ? `<text x="120" y="${Math.max(132, startY + (lineCount - 1) * (fontSize + 4) + 28)}" fill="#fff" fill-opacity=".7" font-size="${subtitleSize}">${escapeSvg(subtitle)}</text>` : ""}
    </g>
  </svg>`;
  const image = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  // 搜索翻页时复用已生成图片，同时限制内存占用。
  if (generatedImages.size >= 128) generatedImages.delete(generatedImages.keys().next().value);
  generatedImages.set(key, image);
  return image;
}
